// Validation for the waste disposal section

// Validating the waste disposal section, but really we only need to validate the disposalDate field
export const validateWasteDisposal = (wasteDisposal) => {
  const errors = {};

  // Validating the disposal date
  const mmddyyyyRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
  if (
    wasteDisposal.disposalDate &&
    wasteDisposal.disposalDate.trim() !== "" &&
    !mmddyyyyRegex.test(wasteDisposal.disposalDate)
  ) {
    errors.disposalDate = "Disposal date is not valid";
  }

  return errors;
};
